import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Tournament } from '../../../../../../models/tournament';
import { TournamentReportOptionsForm } from '../TournamentReportOptionsForm';
interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  tournament: Tournament;
}
export function TournamentResultsIndividualReportForm(props: Props) {
  return (
    <TournamentReportOptionsForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_RESULTS_INDIVIDUAL}
      description="View all results recorded for the selected individual tournament."
      options={[
        {
          field: 'isShowBlank',
          label: 'Show entries without results',
          hint: 'Include entries where a result has not been recorded.',
          initialValue: false
        },
        {
          field: 'isPrintFullNames',
          label: 'Show full names',
          hint: 'Print participant full names in the report.',
          initialValue: true
        }
      ]}
    />
  );
}
